import { useMutation, useQueryClient } from "react-query";
import { mediaSettingsApi } from "@circle-react/api";
import type { UpdateMediaSettingsPayload } from "@circle-react/api/mediaSettingsApi";
import type { ApiError } from "@circle-react/config/CustomErrors";
import type { MediaSetting } from "@circle-react/types/MediaSetting";

interface UseUpdateMediaSettingsOptions {
  onError?: (error: ApiError) => void;
  onSuccess?: (data: MediaSetting) => void;
  signedId: string;
}

export const useUpdateMediaSettings = ({
  onError,
  onSuccess,
  signedId,
}: UseUpdateMediaSettingsOptions) => {
  const queryClient = useQueryClient();

  return useMutation<MediaSetting, ApiError, UpdateMediaSettingsPayload>({
    mutationFn: formData => mediaSettingsApi.update(signedId, formData),
    onSuccess: data => {
      onSuccess?.(data);
      void queryClient.invalidateQueries(["mediaSettings", signedId]);

      const transcriptId = data.transcript?.id;
      if (!transcriptId) return;

      void queryClient.invalidateQueries(["mediaTranscript", transcriptId]);
      void queryClient.invalidateQueries([
        "mediaTranscript",
        "webvtt",
        transcriptId,
      ]);
    },
    onError,
  });
};
